import { surveyInstance } from '..';

const fillSurvey = async (data) => {
  await surveyInstance.post(`/survey/${data.survey._id}/fill`, data);
};

export default fillSurvey;
